@if (formattedLineItemErrors$ | async; as lineItemErrors) {
  @for (errorText of lineItemErrors; track errorText) {
    <glxy-alert class="order-banner" [type]="'warning'">
      {{ 'LIB_ORDERS.SALES_ORDERS.WARNINGS.INVALID_LINE_ITEMS_BANNER_WARNING' | translate
      }}<span [innerHTML]="errorText"></span>
    </glxy-alert>
  }
}
